<form [formGroup]="frmFields" class="g-3 p-2">

  <!-- VIN / Make / Model -->
  <div class="row mt-3">
    <div class="col-md-3">
      <input type="text" formControlName="vin" placeholder="Vehicle Identification Number (VIN)"
        class="form-control form-control-sm">
    </div>
    <div class="col-md-3">
      <input type="text" formControlName="make" placeholder="Make" class="form-control form-control-sm"
        [ngClass]="{ 'is-invalid': (f.make?.touched || submitted) && f.make?.errors?.required }">
      <div class="invalid-feedback" *ngIf="(f.make?.touched || submitted) && f.make?.errors?.required">Make is required.</div>
    </div>
    <div class="col-md-3">
      <input type="text" formControlName="model" placeholder="Model" class="form-control form-control-sm"
        [ngClass]="{ 'is-invalid': (f.model?.touched || submitted) && f.model?.errors?.required }">
      <div class="invalid-feedback" *ngIf="(f.model?.touched || submitted) && f.model?.errors?.required">Model is required.</div>
    </div>
  </div>

  <!-- Trailer Type / Value -->
  <div class="row mt-3">
    <div class="col-md-4" *ngIf="staticData">
      <mat-form-field class="w-100">
        <mat-label>Trailer Type</mat-label>
        <mat-select formControlName="trailer_type" class="form-control form-control-sm"
          [ngClass]="{ 'is-invalid': (f.trailer_type?.touched || submitted) && f.trailer_type?.errors?.required }">
          <mat-option value="">Select</mat-option>
          <mat-option *ngFor="let t of staticData.trailer_body_types" [value]="t">{{t}}</mat-option>
        </mat-select>
      </mat-form-field>
      <div class="invalid-feedback" *ngIf="(f.trailer_type?.touched || submitted) && f.trailer_type?.errors?.required">Trailer type is required.</div>
    </div>
    <div class="col-md-4">
      <div class="input-group">
        <div class="input-group-prepend"><span class="input-group-text bg-success text-white">&pound;</span></div>
        <input type="number" formControlName="value" placeholder="Value"
          class="form-control form-control-sm"
          [ngClass]="{ 'is-invalid': (f.value?.touched || submitted) && f.value?.errors?.required }">
      </div>
      <div class="invalid-feedback" *ngIf="(f.value?.touched || submitted) && f.value?.errors?.required">Value is required.</div>
      <small class="text-muted">Enter the market value if over £100,000.</small>
    </div>
  </div>

  <!-- Cover Info -->
  <div class="row mt-3">
    <div class="col-md-12">
      <p class="text-muted mb-1"><strong>When cover applies:</strong> While attached to a vehicle listed above and continuing once detached until such time the trailer/implement is attached to another vehicle.</p>
      <p class="text-muted"><strong>Cover, terms &amp; limitations:</strong> Same as the insured vehicle to which the trailer/implement is (or was last) attached to.</p>
    </div>
  </div>

</form>
